import Axios from "../../axios-default"
import { isArray } from "util";

const namespaced = true;

const state = () => ({
  controllerId: null,
  params: null,
  loading: false,
  saving: false,
  syncTime: null,
  syncPeriod: 1000 * 60,
  boilerTempMin: 35,
  boilerTempMax: 80,
  boilerTempReducedMin: 0,
  boilerTempReducedMax: 10,
  boilerCalendarParams: null,
  boilerWeatherParams: null,
  cwTempMin: 35,
  cwTempMax: 80,
  cwTempReducedMin: 0,
  cwTempReducedMax: 10,
  cwCalendarParams: null,
  cwWeatherParams: null,
  valveCalendarParams: null,
  valveWeatherParams: null,
  valveCalendarParams: null,
  valveWeatherParams: null,
  calendarSetting: [],
  notifications: [],
  statsTemperature: []
});

const getters = {
  params: state => {
    return state.params
  },
  boilerCalendarArray: (state, getters) => {
    if (state.params) {
      if (isArray(state.boilerCalendarParams)) {
        return getters.calendarParamsToArray(state.boilerCalendarParams)
      } else {
        return null;
      }
    } else {
      return null;
    }
  },
  cwCalendarArray: (state, getters) => {
    if (state.params) {
      if (isArray(state.cwCalendarParams)) {
        return getters.calendarParamsToArray(state.cwCalendarParams)
      } else {
        return null;
      }
    } else {
      return null;
    }
  },
  valveCalendarArray: (state, getters) => {
    if (state.params) {
      if (isArray(state.valveCalendarParams)) {
        return getters.calendarParamsToArray(state.valveCalendarParams)
      } else {
        return null;
      }
    } else {
      return null;
    }
  },
  calendarParamsToArray: (state) => (data) => {
    var ile = data.length, i, binaryWeek = [];
    for (i=0; i < ile; i++) {
      var binary = parseInt(data[i], 10) + 65536;
      binary = binary.toString(2).slice(1);
      var binaryArray = binary.split('').reverse();
      binaryWeek.push(...binaryArray);
    }
    return binaryWeek
  },
  calendarArrayToParams: (state) => (data) => {
    var results = [],
    arr = [...data],
    final = [];
    
    while (arr.length) {
      results.push(arr.splice(0, 16));
    }
    results.forEach(function(el) {
      final.push(parseInt(el.reverse().join(''), 2));
    });
    return final;
  }
};

const mutations = {
  setControllerId(state, controllerId) {
    state.controllerId = controllerId
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setSaving(state, saving) {
    state.saving = saving
  },
  setParams(state, controllerData) {
    state.params = controllerData
  },
  setParam(state, {param, newValue}) {
    state.params[param] = newValue
  },
  setSyncTime(state, syncTime) {
    state.syncTime = syncTime
  },
  boilerCalendarParams(state, val) {
    state.boilerCalendarParams = val
  },
  boilerWeatherParams(state, val) {
    state.boilerWeatherParams = val
  },
  cwCalendarParams(state, val) {
    state.cwCalendarParams = val
  },
  valveCalendarParams(state, val) {
    state.valveCalendarParams = val
  },
  valveWeatherParams(state, val) {
    state.valveWeatherParams = val
  },
  calendarSetting(state, newVal) {
    state.calendarSetting = newVal
  },
  setCalendarSetting(state, {index, val}) {
    state.calendarSetting[index] = val
  },
  notifications(state, data) {
    state.notifications = data
  },
  statsTemperature(state, data) {
    var date = data[0].slice(0, 9);
    state.statsTemperature[date] = data
  }
};

const actions = {
  setControllerId({commit}, controllerId) {
    commit('setControllerId', controllerId);
  },
  async setBoilerMode({commit, rootGetters, state}, boilerMode) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        if (boilerMode == 2) { boilerMode = 1; } 
        
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('boilerMode', boilerMode);
        const res = await Axios.post('/api/sterownik/tryb-pracy-kotla/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'boilerMode', newValue: (res.data.boilerMode == 1 ? 2 : res.data.boilerMode) });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setBoilerCalendar({commit, rootGetters, state}, active) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('active', active);
        const res = await Axios.post('/api/sterownik/kalendarz-kotla?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'boilerCalendar', newValue: res.data.active });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setCwCalendar({commit, rootGetters, state}, active) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('active', active);
        const res = await Axios.post('/api/sterownik/kalendarz-cw?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'cwCalendar', newValue: res.data.active });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setValveCalendar({commit, rootGetters, state}, active) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('active', active);
        const res = await Axios.post('/api/sterownik/kalendarz-zawor?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'valveCalendar', newValue: res.data.active });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setBoilerWeatherMode({commit, rootGetters, state}, active) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('active', active);
        const res = await Axios.post('/api/sterownik/tryb-pogodowy-kotla/aktywacja?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'boilerWeatherMode', newValue: res.data.active });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setValveWeatherMode({commit, rootGetters, state}, active) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('active', active);
        const res = await Axios.post('/api/sterownik/tryb-pogodowy-zawor/aktywacja?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'valveWeatherMode', newValue: res.data.active });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setBoilerWeather({commit, rootGetters, state}, { tempM20, tempM10, temp0, temp10 }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('tempM20', tempM20);
        formData.append('tempM10', tempM10);
        formData.append('temp0', temp0);
        formData.append('temp10', temp10);

        const res = await Axios.post('/api/sterownik/tryb-pogodowy-kotla/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'boilerWeatherParams', newValue: res.data });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setValveWeather({commit, rootGetters, state}, { tempM20, tempM10, temp0, temp10 }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('tempM20', tempM20);
        formData.append('tempM10', tempM10);
        formData.append('temp0', temp0);
        formData.append('temp10', temp10);

        const res = await Axios.post('/api/sterownik/tryb-pogodowy-zawor/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'valveWeatherParams', newValue: res.data });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setBoilerTemp({commit, rootGetters, state}, { boilerTempSet, boilerTempReduced }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('tempObnizona', boilerTempReduced);
        formData.append('tempZadana', boilerTempSet);
        
        const res = await Axios.post('/api/sterownik/temp-kotla/zapisz?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'boilerTempSet', newValue: res.data.tempZadana });
          commit('setParam', { param: 'boilerTempReduced', newValue: res.data.tempObnizona });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setValveTemp({commit, rootGetters, state}, { tempSet, tempReduced }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('tempZadana', tempSet);
        formData.append('tempObnizona', tempReduced);
        const res = await Axios.post('/api/sterownik/temp-zawor/zapisz?t=' + Date.now(), formData);
        console.log(res.data);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'valveTempSet', newValue: res.data.tempZadana });
          commit('setParam', { param: 'valveTempReduced', newValue: res.data.tempObnizona });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setCwTemp({commit, rootGetters, state}, { tempSet }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        //formData.append('tempObnizona', cwTempReduced);
        formData.append('cwTempSet', tempSet);
        console.log(tempSet);
        const res = await Axios.post('/api/sterownik/temp-cw/zapisz?t=' + Date.now(), formData);
        console.log(res.data);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'cwTempSet', newValue: res.data.cwTempSet });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setCwMode({commit, rootGetters, state}, cwMode) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('cwMode', cwMode);
        const res = await Axios.post('/api/sterownik/tryb-pracy-cw/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          commit('setParam', { param: 'cwMode', newValue: res.data.cwMode });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async syncController ({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading && (forced || state.syncTime === null || new Date().getTime() - state.syncTime > state.syncPeriod)) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/dane?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
          if (forced == true) {
            commit("alert", {color: "error", text: '0'}, { root: true });
          }
        } else {
          commit('setLoading', false);
          commit('setParams', res.data);
          commit('setSyncTime', new Date().getTime());
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getBoilerWeather({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/tryb-pogodowy-kotla?t=' + Date.now(), formData);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('boilerWeatherParams', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getValveWeather({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/tryb-pogodowy-zawor?t=' + Date.now(), formData);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('valveWeatherParams', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getBoilerCalendarParams({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/harmonogram-co?t=' + Date.now(), formData);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('boilerCalendarParams', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setBoilerCalendarParams({commit, rootGetters, state}, { schedule }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        schedule.forEach(function(el, i) {
          formData.append('schedule['+i+']', el);
        });
        
        const res = await Axios.post('/api/sterownik/harmonogram-co/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } 
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getCwCalendarParams({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/harmonogram-cw?t=' + Date.now(), formData);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('cwCalendarParams', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setCwCalendarParams({commit, rootGetters, state}, { schedule }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        schedule.forEach(function(el, i) {
          formData.append('schedule['+i+']', el);
        });
        
        const res = await Axios.post('/api/sterownik/harmonogram-cw/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } 
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getValveCalendarParams({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        
        const res = await Axios.post('/api/sterownik/harmonogram-zawor?t=' + Date.now(), formData);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('valveCalendarParams', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async setValveCalendarParams({commit, rootGetters, state}, { schedule }) {
    try {
      if (!state.saving) {
        commit('setSaving', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        schedule.forEach(function(el, i) {
          formData.append('schedule['+i+']', el);
        });
        
        const res = await Axios.post('/api/sterownik/harmonogram-zawor/edytuj?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else if (!res.data.error) {
          //commit('setParam', { param: 'boilerTempSet', newValue: res.data.tempZadana });
        }
        commit('setSaving', false);
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getNotifications({commit, rootGetters, state}, forced) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('startIndex', 1);
        formData.append('itemsPerPage', 20);
        
        const res = await Axios.post('/api/sterownik/alarm/lista?t=' + Date.now(), formData);
        console.log(res);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('notifications', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  async getStatsTemperature({commit, rootGetters, state}, date) {
    try {
      if (!state.loading) {
        commit('setLoading', true);
        const formData = new URLSearchParams();
        formData.append('controllerId', state.controllerId);
        formData.append('token', rootGetters.token);
        formData.append('date', '27.10.2019');
        
        const res = await Axios.post('/api/sterownik/wykresy/temperatura?t=' + Date.now(), formData);
        console.log(res);
        commit('setLoading', false);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:0}};
        } else {
          commit('statsTemperature', res.data);
        }
        return res.data;
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}
